import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";

export async function fetchExcelFile(KANDIDAT_ID: number) {
  const res = await ApiClient.get(
    `/ExportKandidatExcel?id=${KANDIDAT_ID}`,
    {
      responseType: "arraybuffer",
      headers: { "Content-Type": "blob" },
    }
  );
  return res;
}

export const useFetchExcelFile = mutationWrapper(fetchExcelFile);
